import { render, staticRenderFns } from "./set-neg-keyword-modal.vue?vue&type=template&id=8b128762&scoped=true&"
import script from "./set-neg-keyword-modal.vue?vue&type=script&lang=js&"
export * from "./set-neg-keyword-modal.vue?vue&type=script&lang=js&"
import style0 from "./set-neg-keyword-modal.vue?vue&type=style&index=0&id=8b128762&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b128762",
  null
  
)

export default component.exports